import { render, staticRenderFns } from "./media-filter.vue?vue&type=template&id=b3c3fde6"
import script from "./media-filter.vue?vue&type=script&lang=js"
export * from "./media-filter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports